import { BooleanDimension, ExclusionDimension } from '@orus.eu/dimensions'

export const frRcpSelectedDimension = new BooleanDimension({
  name: 'frRcpSelected',
  displayKeys: { name: 'dimension_name_fr_rcp_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpExclusionsDimension = new ExclusionDimension({
  name: 'frRcpExclusions',
  displayKeys: { name: 'dimension_name_fr_rcp_exclusions' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpShouldAskActivitiesDistributionDimension = new BooleanDimension({
  name: 'frRcpShouldAskActivitiesDistribution',
  displayKeys: { name: 'dimension_name_fr_rcp_should_ask_activities_distribution' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
